export default __webpack_public_path__ + "static/media/regulatory--end-of-prohibition--g1.24827b34.png";